module.exports = __webpack_public_path__ + "KaTeX_Fraktur-Regular.87ae4332.ttf";